import { render, staticRenderFns } from "./ExternalChangesHistory.vue?vue&type=template&id=d489cc76&scoped=true&"
import script from "./ExternalChangesHistory.vue?vue&type=script&lang=js&"
export * from "./ExternalChangesHistory.vue?vue&type=script&lang=js&"
import style0 from "./ExternalChangesHistory.vue?vue&type=style&index=0&id=d489cc76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d489cc76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
